import React, { useState, useEffect } from 'react';
import { 
  Grid, Paper, TextField, Button, CircularProgress, Snackbar, 
  MenuItem, ToggleButton, ToggleButtonGroup, Typography, Box 
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import MuiAlert from '@mui/material/Alert';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { format } from 'date-fns';
import enIN from 'date-fns/locale/en-IN';
import axios from 'axios';
import { authenticationService } from "src/services";
import { get,post } from 'src/services/httpClient.service';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { useWalletContext } from 'src/components/walletcontexthook';

const CreateUserSubscription = (props) => {
  const { fetchFranchisees } = useWalletContext();/* auto update for wallet */

  const { showSnackbar } = useSnackbar();
  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();
  const URL_PATH = authenticationService.getVendorFranchisePath();
  const [formValues, setFormValues] = useState({
    users: '',
    phone: '',
    email: '',
    stbNo: '',
    packageId: 0,
    packages: '',
    planAmount: '',
    details: '',
    location: '',
    billingAddress: '',
    installationAddress: '',
    paymentStatus: 'Pending',
    //startDate: null,
    //endDate: null,
    planDuration: "1",
    vendorId: vendorId,
    franchiseId: franchiseId,
    selectedPackageIds: [],
    selectedPackageList: []
  });

  const [errors, setErrors] = useState({
  email: "",
  users: "",
  phone: "",
  selectedPackageIds: "",
  planAmount: "",
  startDate: "",
  endDate: ""
});

  
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [users, setUsers] = useState([]);
  const [packages, setPackages] = useState([]);
  const [alaCartePackages, setAlaCartePackages] = useState('');
  const [walletAmount, setWalletAmount] = useState('0.0');

  

  useEffect(() => {
    fetchUsers();
    fetchPackages();
  }, []);

  // Fetch inactive-users from backend API
  const fetchUsers = async () => {
    try {
      const response = await get(`${process.env.REACT_APP_BASE_API_URL}/api/subscriber/vendor/${vendorId}/franchise/${franchiseId}/subscription-expired-users`);
      //inactive-users
      if (response && response.status === 'OK') {
        const userList = response.userList;
        
        // Format user location for display
        const formattedUsers = userList.map(user => ({
          ...user,
          // Create a formatted location string
          formattedLocation: formatUserLocation(user, 'LOCATION'),
          formattedBillingAddress: formatUserLocation(user, 'ADDRESS'),
          formattedInstallationAddress: formatUserLocation(user, 'INSTALLATION_ADDRESS')
        }));
        
        setUsers(formattedUsers);
      } else {
        console.error('Failed to fetch users:', response.responseMessage);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  // Helper function to format user location
  const formatUserLocation = (user, type) => {
    if (!user) return '';
    
    const parts = [];

    if(type=="LOCATION") {
      //if (user.address) parts.push(user.address);
      if (user.city) parts.push(user.city);
      if (user.state) parts.push(user.state);
      //if (user.zipCode) parts.push(user.zipCode);
    }
    if(type=="ADDRESS") {
      if (user.billingAddress1) parts.push(user.billingAddress1);
      if (user.billingAddress2) parts.push(user.billingAddress2);
      if (user.billingCity) parts.push(user.billingCity);
      if (user.billingState) parts.push(user.billingState);
      if (user.billingZipCode) parts.push(user.billingZipCode);
    }

    if(type=="INSTALLATION_ADDRESS") {
      if (user.address) parts.push(user.address);
      if (user.address1) parts.push(user.address1);
      if (user.city) parts.push(user.city);
      if (user.state) parts.push(user.state);
      if (user.zipCode) parts.push(user.zipCode);
    }

    return parts.join(', ');
  };

  // Fetch packages from backend API
  const fetchPackages = async () => {
    try {
      const response = await get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}/vendor/${vendorId}/findAll`);
      if (Array.isArray(response)) {
        const selectedPackages = response
  .filter((pkg) => pkg.packageType !== "A-LA-CARTE")
  .map((pkg) => ({
    id: pkg.id,
    planName: pkg.planName,
    planAmount: pkg.planAmount,
    biMonthlyAmount: pkg.biMonthlyAmount,
    quarterlyAmount: pkg.quarterlyAmount,
    halfYearlyAmount: pkg.halfYearlyAmount,
    annualAmount: pkg.annualAmount,
    packageType: pkg.packageType,
    details: pkg.details
  }));

        const selectedAlaCarteChannels = response
          .filter(pkg => pkg.packageType === 'A-LA-CARTE')
          .map(pkg => pkg.planName)
          .join(',');

        setAlaCartePackages(selectedAlaCarteChannels);
        setPackages(selectedPackages);
      } else {
        console.error('Invalid data format for packages:', response);
      }
    } catch (error) {
      console.error('Error fetching packages:', error);
    }
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  /* const handleStartDateChange = (date) => {
    if (!date || isNaN(new Date(date))) {
      setFormValues({ ...formValues, startDate: null });
      return;
    }
    const formattedDate = format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss", { locale: enIN });
    setFormValues({ ...formValues, startDate: formattedDate });
  }; */

  /* const handleEndDateChange = (date) => {
    if (!date || isNaN(new Date(date))) {
      setFormValues({ ...formValues, endDate: null });
      return;
    }
    const formattedDate = format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss", { locale: enIN });
    setFormValues({ ...formValues, endDate: formattedDate });
  }; */

 const getAmountByDuration = (pkg, duration) => {
  switch (String(duration)) {
    case "2":
      return Number(pkg.biMonthlyAmount ?? pkg.planAmount ?? 0);
    case "3":
      return Number(pkg.quarterlyAmount ?? pkg.planAmount ?? 0);
    case "6":
      return Number(pkg.halfYearlyAmount ?? pkg.planAmount ?? 0);
    case "12":
      return Number(pkg.annualAmount ?? pkg.planAmount ?? 0);
    case "1":
    default:
      return Number(pkg.planAmount ?? 0);
  }
};



  const handlePackageChange = (event) => {
    const { value } = event.target;

    setErrors((prev) => ({
    ...prev,
    selectedPackageIds: "",
  }));
    
    const selectedPackages = packages
  .filter((pkg) => value.includes(pkg.id))
  .map((pkg) => ({
    id: pkg.id,
    planName: pkg.planName,
    planAmount: pkg.planAmount,
    biMonthlyAmount: pkg.biMonthlyAmount,
    quarterlyAmount: pkg.quarterlyAmount,
    halfYearlyAmount: pkg.halfYearlyAmount,
    annualAmount: pkg.annualAmount,
    packageType: pkg.packageType,
    details: pkg.details,
    appType: pkg.appType,
    planId: pkg.planId
  }));


    // Calculate total price
    //const totalPrice = selectedPackages.reduce((sum, pkg) => sum + Number(pkg.planAmount || 0), 0);
   const duration = formValues.planDuration || "1";

const totalPrice = selectedPackages.reduce(
  (sum, pkg) => sum + getAmountByDuration(pkg, duration),
  0
);

   
    const packageDetails = selectedPackages.reduce((result, pkg, index) => {
      const details = pkg.details || '';
      return result + (index > 0 ? ', ' : '') + details;
    }, '');

    setFormValues((prev) => ({
      ...prev,
      selectedPackageIds: value,
      selectedPackageList: selectedPackages,
      packageId: selectedPackages.id,
      packages: selectedPackages.planName,
      planAmount: totalPrice,
     
      details: packageDetails
    }));
  };

  // const handleChange = (e) => {
  //   const selectedEmail = e.target.value;
  //   const selectedUser = users.find(user => user.email === selectedEmail);
  //   if (selectedUser) {
  //     setFormValues({
  //       ...formValues,
  //       users: selectedUser.firstName,
  //       email: selectedEmail,
  //       phone: selectedUser.phone,
  //       stbNo: selectedUser.devices,
  //       location: selectedUser.formattedLocation,
  //       billingAddress: selectedUser.formattedBillingAddress,
  //     });
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      // Special case: when selecting email from dropdown
      const selectedUser = users.find(user => user.email === value);
      if (selectedUser) {
        console.log("selectedUser:::", selectedUser)
        setFormValues((prev) => ({
          ...prev,
          email: value,
          users: selectedUser.firstName,
          phone: selectedUser.phone,
          stbNo: selectedUser.devices,
          location: selectedUser.formattedLocation || '',
          billingAddress: selectedUser.billingAddress || '',
          installationAddress: selectedUser.shippingAddress || ''
        }));
        setWalletAmount(selectedUser.walletAmount);
      }
    } else {
      // For all other fields (editable)
      setFormValues((prev) => ({
        ...prev,
        [name]: value
      }));
    }

    setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
  };


  const handlePaymentStatusChange = (event, newPaymentStatus) => {
    setFormValues({ ...formValues, paymentStatus: newPaymentStatus });
  };

  const validateForm = () => {
  let tempErrors = {
    email: "",
    users: "",
    phone: "",
    selectedPackageIds: "",
    planAmount: "",
    //startDate: "",
    //endDate: ""
  };

  if (!formValues.email) tempErrors.email = "Email is required";
  if (!formValues.users.trim()) tempErrors.users = "User name is required";
  if (!formValues.phone.trim()) tempErrors.phone = "Phone number is required";
  if (formValues.selectedPackageIds.length === 0)
    tempErrors.selectedPackageIds = "Select at least one package";
  if (!formValues.planAmount) tempErrors.planAmount = "Plan amount is required";
 // if (!formValues.startDate) tempErrors.startDate = "Start date is required";
  //if (!formValues.endDate) tempErrors.endDate = "End date is required";

  /* if (formValues.startDate && formValues.endDate ) {
    const start = new Date(formValues.startDate);
    const end = new Date(formValues.endDate);
    if (start > end ) {
      tempErrors.startDate = "Start date cannot be after end date";
      tempErrors.endDate = "End date cannot be before start date";
    }
    if (start.getTime() === end.getTime()) {
      tempErrors.startDate = "Start date cannot be after end date";
      tempErrors.endDate = "End date cannot be before start date";
    }
  } */

  setErrors(tempErrors);

  // ✅ return true if all errors are empty
  return Object.values(tempErrors).every((msg) => msg === "");
};


  const onSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      //console.log(formValues);
      //return;
      formValues.vendorId = vendorId;
      formValues.franchiseId = franchiseId;
      const response = await createUserSubscription(formValues);
      setLoading(false);


     
    } catch (error) {
      setLoading(false);
      setSnackbarSeverity('error');
      setSnackbarMessage('Error while creating user subscription.');
      setSnackbarOpen(true);
    }
  };

  async function createUserSubscription(data) {
    try {
     const response = await post(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_USERSUBSCRIPTION}`, data);
      console.log('response1',response.data)
      console.log('response2',response)
      if(response.responseCode === '200'){
       showSnackbar('User subscription created','success')
       props.onClose();
       await fetchFranchisees()
            props.fetchUserData();
      }else{
         showSnackbar('User subscription failed to created','error')
      }
        
      return response.data;
    } catch (error) {
      if(error?.response?.data?.data!=undefined && error?.response?.data?.data!="") {
      console.log('check',error?.response?.data?.data,'error')
      showSnackbar(error?.response?.data?.data,'error')
    } else {
      showSnackbar('Create Subscription Failed','error')
    } 
      return null;
    }
  }

  // useEffect(() => {
  //   if (formValues.email) {
  //     const selectedUser = users.find(user => user.email === formValues.email);
  //     setFormValues(prev => ({
  //       ...prev,
  //       location: selectedUser?.formattedLocation || '',
  //       billingAddress: selectedUser?.formattedBillingAddress || ''
  //     }));
  //   }
  // }, [formValues.email, users]);

  return (
    <>
      <Helmet>
        <title>Create User Subscription</title>
      </Helmet>
      <Paper elevation={3} style={{ padding: '20px' }}>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                required
                id="email"
                name="email"
                value={formValues.email}
                label="Email"
                fullWidth
                error={!!errors.email}
                helperText={errors.email}
                onChange={handleChange}
              >
                {users.map((usr) => (
                  <MenuItem key={usr.id} value={usr.email}>
                    {usr.email}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <b style={{ fontSize: '18px' }}>Wallet Amount: </b><br />{walletAmount}
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="users"
                name="users"
                value={formValues.users}
                label="User Name"
                fullWidth
                InputProps={{ readOnly: true }}
                error={!!errors.users}
                helperText={errors.users}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="phone"
                name="phone"
                value={formValues.phone}
                label="Phone Number"
                InputProps={{ readOnly: true }}
                fullWidth
                error={!!errors.phone}
                 helperText={errors.phone}
                
                onChange={handleChange}
              />
            </Grid>
            
            {/* Location Display */}
            {/* <Grid item xs={12} sm={6}>
              <TextField
                id="location"
                label="Location"
                name="location"
                InputProps={{ readOnly: true }}
                fullWidth
                value={formValues.location || ''}
                onChange={handleChange}
              />
            </Grid> */}
            {/* Billing Address */}
            <Grid item xs={12} sm={6}>
              <TextField
                id="billingAddress"
                name="billingAddress"
                label="Billing Address"
                fullWidth
                InputProps={{ readOnly: true }}
                value={formValues.billingAddress || ''}
                onChange={handleChange}
              />
            </Grid>
              
            {/* Installation Address */}
            <Grid item xs={12} sm={6}>
              <TextField
                id="installationAddress"
                name="installationAddress"
                label="Installation Address"
                fullWidth
                InputProps={{ readOnly: true }}
                value={formValues.installationAddress || ''}
                onChange={handleChange}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                required
                id="selectedPackageIds"
                name="selectedPackageIds"
                select
                label="Packages List"
                fullWidth
                error={!!errors.selectedPackageIds}
                helperText={errors.selectedPackageIds}
                SelectProps={{
                  multiple: true
                }}
                value={formValues.selectedPackageIds}
                onChange={handlePackageChange}
              >
                {packages.map((pkg) => (
                  <MenuItem key={pkg.id} value={pkg.id}>
                    {pkg.planName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            
            
            
            <Grid item xs={12} sm={6}>
              <TextField
                id="details"
                value={formValues.details}
                label="Details"
                fullWidth
                onChange={handleChange}
              />
            </Grid>
            
            {/* <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Start Date"
                  value={formValues.startDate}
                  onChange={handleStartDateChange}
                  minDate={new Date()}
                  renderInput={(params) => <TextField {...params} fullWidth error={!!errors.startDate}
                 helperText={errors.startDate} />}
                />
              </LocalizationProvider>
            </Grid> */}
            
            {/* <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="End Date"
                  value={formValues.endDate}
                  onChange={handleEndDateChange}
                  minDate={new Date()}
                  renderInput={(params) => <TextField {...params} fullWidth error={!!errors.endDate}
                  helperText={errors.endDate}/>}
                />
              </LocalizationProvider>
            </Grid>
 */}
            <Grid item xs={12} sm={6}>
  <TextField
  select
  fullWidth
  label="Plan Duration"
  name="planDuration"
  value={formValues.planDuration}
  onChange={(e) => {
    const duration = e.target.value;

    const totalAmount = formValues.selectedPackageList.reduce(
      (sum, pkg) => sum + getAmountByDuration(pkg, duration),
      0
    );

    setFormValues((prev) => ({
      ...prev,
      planDuration: duration,
      planAmount: totalAmount
    }));
  }}
>

    <MenuItem value="1">Monthly (1 Month)</MenuItem>
    <MenuItem value="2">Bi-Monthly (2 Months)</MenuItem>
    <MenuItem value="3">Quarterly (3 Months)</MenuItem>
    <MenuItem value="6">Half-Yearly (6 Months)</MenuItem>
    <MenuItem value="12">Annual (12 Months)</MenuItem>
  </TextField>
</Grid>


<Grid item xs={12} sm={6}>
  <TextField
  required
  label="Plan Amount"
  value={formValues.planAmount}
  fullWidth
  InputProps={{ readOnly: true }}
/>

</Grid>




            
            {/* <Grid item xs={12} sm={6}>
              <ToggleButtonGroup
                id="paymentStatus"
                value={formValues.paymentStatus}
                exclusive
                onChange={handlePaymentStatusChange}
                aria-label="payment status"
              >
                <ToggleButton value="Pending" aria-label="pending">
                  Pending
                </ToggleButton>
                <ToggleButton value="Completed" aria-label="completed">
                  Completed
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid> */}
          </Grid>
          
          <div style={{ marginTop: '20px', textAlign: 'right' }}>
            <Button onClick={onSubmit} variant="contained" disabled={loading}>
              {loading ? <CircularProgress size={24} /> : 'Create'}
            </Button>
            <Button style={{ marginLeft: '8px' }} onClick={handleClose} variant="contained" disabled={loading}>
              Cancel
            </Button>
          </div>
        </form>
      </Paper>
      
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default CreateUserSubscription;